'use client';

import { useContext } from 'react';
import { RouterContext } from 'next/dist/shared/lib/router-context.shared-runtime';
import { useLocale } from '@hooks/useLocale';
import { useTranslations } from 'next-intl';
import cn from 'classnames';
import Container from '@components/global/Container';
import PromotionalTicker from '@components/global/PromotionalTicker';
import Skeleton from 'react-loading-skeleton';
import { PromoTicker } from '@adapters/prismic/types/promoTicker';

import style from './TopRibbon.module.scss';

interface TopRibbonProps {
  alternateLocaleUrl?: string;
  promoTickerMessages: PromoTicker[];
}

const TopRibbon = ({
  alternateLocaleUrl,
  promoTickerMessages,
}: TopRibbonProps) => {
  // Dual router compatibility: isFallback only exists in Pages Router
  const pagesRouter = useContext(RouterContext);
  const isFallback = pagesRouter?.isFallback || false;

  const locale = useLocale();
  const t = useTranslations('common');
  return (
    <div className={cn(style.topRibbon)}>
      <a href="#main-content" className={style.skipLink}>
        {t('skip.to.content')}
      </a>
      <a href="#navigation" className={style.skipLink}>
        {t('skip.to.navigation')}
      </a>
      <Container className={style.container}>
        <PromotionalTicker messages={promoTickerMessages} />
        <a
          className={style.localeLink}
          href={alternateLocaleUrl ?? `/${locale === 'en' ? 'fr' : 'en'}`}
        >
          {isFallback ? <Skeleton width={42} /> : t('alternate.locale.link')}
        </a>
      </Container>
    </div>
  );
};

export default TopRibbon;
